import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../service/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  isLoggingIn: boolean = false;
  saveLoginChecked = false;
  hidePasswordField: boolean = true;

  //Konstanten (keys)
  PASSWORD = 'password';
  USERNAME = 'username';
  SAVELOGIN = 'saveLoginChecked';

  constructor(private formBuilder: FormBuilder,
              private authService: AuthService) {
  }

  ngOnInit() {

    //Loginformular - Referenz auf das HTML
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.email],
      password: ['', Validators.required]
    });
  }

  //Login wird ausgeführt und ggf. im Sessionstorage gespeichert
  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoggingIn = true;
      const username = this.loginForm.get(this.USERNAME).value;
      const password = this.loginForm.get(this.PASSWORD).value;
      this.authService.signIn(username, password, this.saveLoginChecked).finally(() => this.isLoggingIn = false);
    }
  }


}
